"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  environments: ["production"],
  googleAnalytics: {
    cookieName: "gatsby-gdpr-google-analytics",
    anonymize: true
  },
  googleTagManager: {
    cookieName: "gatsby-gdpr-google-tagmanager",
    dataLayerName: "dataLayer"
  },
  facebookPixel: {
    cookieName: "gatsby-gdpr-facebook-pixel"
  }
};
exports.default = _default;